import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";
import { DeliveryStatusEnum } from "@/constants/enums/deliveryStatus.enum";
import { ExpeditionBlockedReasonEnum } from "@/constants/enums/expeditionBlockedReason.enum";

export const DeliveryStatusFormSchema = z
  .object({
    deliveryStatus: z.nativeEnum(DeliveryStatusEnum),
    blockedReason: z.nativeEnum(ExpeditionBlockedReasonEnum).optional(),
  })
  .refine(
    (data) => data.deliveryStatus !== DeliveryStatusEnum.FAILED || data.blockedReason !== undefined,
    {
      message: i18nMessage("boExpeditions:deliveryStatusModal.blockedReasonRequired"),
      path: ["blockedReason"],
    },
  );

export type DeliveryStatusFormData = z.infer<typeof DeliveryStatusFormSchema>;
